// eslint-disable-next-line import/prefer-default-export
export function getFileNameFromHeaders(
	headers: Record<string, string> | null,
	fallbackFileName: string,
): string {
	const contentDisposition = headers?.["content-disposition"];
	const matchedGroup = contentDisposition?.match(/filename="(.+)"/);
	return matchedGroup?.[1] || fallbackFileName;
}
